import { Alert, Button, Drawer, Empty, Table } from 'antd';

const BillingHistoryDrawer = ({
  open,
  onClose,
  onRefresh,
  historyLoading,
  historyError,
  historyItems,
  historyColumns,
  historyPage,
  historyTotal,
  pageSize,
  onPageChange,
}) => (
  <Drawer
    title="历史订阅记录"
    placement="right"
    width="min(760px, 92vw)"
    open={open}
    onClose={onClose}
    extra={(
      <Button type="link" onClick={onRefresh} loading={historyLoading}>
        刷新
      </Button>
    )}
  >
    {historyError && (
      <Alert
        type="error"
        showIcon
        message="加载失败"
        description={historyError}
        style={{ marginBottom: 12 }}
      />
    )}
    <Table
      className="billing-history-table"
      size="middle"
      rowKey={(record) => String(record?.history_id || record?.payment_id || record?.out_trade_no || '')}
      dataSource={historyItems}
      columns={historyColumns}
      loading={historyLoading}
      pagination={{
        current: historyPage,
        pageSize,
        total: historyTotal,
        showSizeChanger: false,
        showTotal: (total) => `共 ${total} 条`,
        onChange: onPageChange,
      }}
      scroll={{ x: 860 }}
      locale={{
        emptyText: historyLoading
          ? '加载中...'
          : <Empty description="暂无历史订阅记录" image={Empty.PRESENTED_IMAGE_SIMPLE} />,
      }}
    />
  </Drawer>
);

export default BillingHistoryDrawer;
